import { DOCUMENT } from '@angular/common';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { firstValueFrom, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoginRedirectService {
  private readonly LOGIN_ENDPOINT = 'links/login';
  private loginUrl: string | undefined;
  private httpClient: HttpClient;

  constructor(
    handler: HttpBackend,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.httpClient = new HttpClient(handler);
  }

  loadLoginPage = (): Promise<object> => {
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'No-Auth': 'True',
    });
    const login$ = this.httpClient.get(`/api/v1/${this.LOGIN_ENDPOINT}`, { headers: reqHeader }).pipe(
      tap(res => {
        // @ts-ignore
        this.loginUrl = res['data'].endsWith('/') ? res['data'].slice(0, -1) : res['data'];
      }),
      catchError(err => {
        throw new Error(err);
      }),
    );
    return firstValueFrom(login$);
  };

  goToLogin = (): void => {
    this.document.location.href = `${this.loginUrl}?redirect_url=${location.href}`;
  };

  logout = (): void => {
    this.document.location.href = this.loginUrl + '/logout';
  };
}
